import CustomModal from "../CustomModal";

const SubscriptionSuccessModal = ({
  isOpen,
  onClose,
  adminProfile,
  isPaymentConfirmed = false,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Success Modal"
      className="edit-success-modal"
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/thumbs-up.png`}
        alt="Success icon"
      />

      {isPaymentConfirmed ? (
        <h2>Payment Confirmed</h2>
      ) : adminProfile?.role?.id === 3 ? (
        <>
          <h2>Awaiting Payment Approval</h2>
          <p>Kindly confirm payment</p>
        </>
      ) : (
        <>
          <h2>Awaiting Payment Approval</h2>
          <p>A super admin will confirm this payment soon</p>
        </>
      )}

      <button onClick={onClose}>Close</button>
    </CustomModal>
  );
};

export default SubscriptionSuccessModal;
